<template>
    <div>
        <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline title">{{ $t('rms.exit.thanks.title') }}</h3>
                <div class="pa-2 "> {{$t('rms.exit.message')}} </div>
              </div>
            </v-card-title>
        </v-card>
          <router-link to="/login">{{$t('rms.button.login_as_distributor')}}</router-link>
    </div>
</template>
<script>
export default {
    name:"ExitPage",
}
</script>
